
@if (control) {
  <div class="relative">
    <label class="input-label" [for]="id+'_sub'">{{fullLabel}}</label>
    <div class="relative shadow-sm">
      <textarea class="input disabled:bg-extend-grey" [id]="id+'_sub'" [formControl]="control" [readonly]="readonly ? 'readonly' : null" [class.input-invalid]="!control.valid &amp;&amp; control.enabled &amp;&amp; control.touched" [class.font-mono]="displayAsCode" [placeholder]="label" [attr.aria-invalid]="!control.valid &amp;&amp; control.enabled &amp;&amp; control.touched" [attr.aria-describedby]="id+'_sub_error'" [rows]="rows"></textarea>
    </div>@if (!control.valid && control.enabled && control.touched) {
    <span class="input-invalid-hint" [id]="id+'_sub_error'">{{ control.value | inputErrorMessage:control }}</span>
  }
</div>
}